import {
  Box,
  Theme,
  makeStyles,
  createStyles,
  SvgIcon,
  ButtonBase,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";

import { Tick, Close } from "~components/Icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      width: 336,

      padding: `${theme.spacing(2)}px ${theme.spacing(1.5)}px`,

      backgroundColor: theme.palette.dark.main,

      borderRadius: 4,
      boxShadow: "0 10px 12px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
    },
    text: {
      fontSize: 14,
      lineHeight: 2.3,
      letterSpacing: 0,
      color: "white",
    },
    success: {
      "& svg": {
        fontSize: 32,
        color: theme.palette.success.main,
      },
    },
    error: {
      "& svg": {
        fontSize: 32,
        color: theme.palette.error.main,
      },
    },
    action: {
      marginRight: 12,

      fontSize: 14,
      lineHeight: "19px",
      fontWeight: 700,
      color: theme.palette.success.main,
      textTransform: "uppercase",

      "&:hover": {
        color: theme.palette.success.dark,
      },
    },
  }),
);

type ToastProps = {
  type?: "action" | "success" | "error";
  message: string;
  action?: () => void;
  actionLabel?: string;
};

export const Toast = ({ message, action, actionLabel, type = "action" }: ToastProps) => {
  let icon;
  const classes = useStyles();

  if (type !== "action") {
    icon = type === "success" ? Tick : Close;
  }

  return (
    <Box
      className={clsx(classes.container, {
        [classes.success]: type === "success",
        [classes.error]: type === "error",
      })}
    >
      <Box display="flex" alignItems="center">
        {typeof icon !== "undefined" && <SvgIcon component={icon} />}
        <Typography
          className={classes.text}
          style={{ marginLeft: typeof icon !== "undefined" ? "4px" : "12px" }}
        >
          {message}
        </Typography>
      </Box>
      {typeof action === "function" && (
        <ButtonBase onClick={action} className={classes.action}>
          {actionLabel}
        </ButtonBase>
      )}
    </Box>
  );
};
